import axios from 'axios'
import { XHH_HOST } from '@/configs/xhconfig'
import {deviceToken, isIos, checkMobile, getCookie} from '@/utils'

// 请求取消
const CancelToken = axios.CancelToken
const source = CancelToken.source()

let platform = 'PC'
if (checkMobile()) {
  platform = isIos ? 'IOS' : 'ANDROID'
}

const instance = axios.create({
  'baseURL': XHH_HOST,
  'timeout': 300000,
  'cancelToken': source.token
})

instance.interceptors.request.use(function (config) {
  config.headers['device-token'] = deviceToken()
  config.headers['platform'] = platform
  config.headers['version'] = '8.8.62'
  config.headers['user-uuid'] = getCookie('xhw_auth_sign') || ''
  if (config.headers['Content-Type'] !== 'application/json') {
    let formData = new FormData(), data = config.data
    for (let i in data) {
      formData.set(i, data[i])
    }
    config.data = formData
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return error.response
})

export default instance
